(function () {
  const ROOT_SELECTOR = "#A2TVMAX";

  function init(root) {
    if (!root || root.dataset.maxProductReady === "true") return;

    const cards = Array.from(root.querySelectorAll("[data-max-variant-card]"));
    const form = root.querySelector("[data-max-product-form]");
    const variantInput = form && form.querySelector('input[name="id"]');
    const submit = form && form.querySelector('[name="add"]');
    const currentPrice = root.querySelector("[data-max-current-price]");
    const selectedName = root.querySelector("[data-max-selected-name]");
    const formError = form && form.querySelector(".max-form-error");
    const formShell = form && (form.closest(".max-purchase-form") || form);

    if (root.dataset.maxUiReady !== "true") {
      root.querySelectorAll('a[href="#max-buy"]').forEach(function (link) {
        if (link.id === "hero-buy" || link.id === "final-buy") {
          link.textContent = "Choose your setup";
        } else {
          link.textContent = "Choose setup";
        }
      });

      const shippingNote = root.querySelector(".hero-ship");
      if (shippingNote) {
        shippingNote.textContent = "Shipping calculated at checkout";
      }

      const stickyBuy = root.querySelector("#buybar-buy");
      const stickyShipping = root.querySelector(".buybar-ship");
      const stickyBar = root.querySelector("#buybar");
      const purchaseSection = root.querySelector("#max-buy");
      if (stickyBuy) stickyBuy.textContent = "Choose setup";
      if (stickyShipping) stickyShipping.textContent = "Shipping at checkout";
      if (stickyBar && purchaseSection && "IntersectionObserver" in window) {
        const purchaseObserver = new IntersectionObserver(
          function (entries) {
            stickyBar.classList.toggle("max-buy-in-view", entries[0].isIntersecting);
          },
          { threshold: 0.08 }
        );
        purchaseObserver.observe(purchaseSection);
      }
      root.dataset.maxUiReady = "true";
    }

    if (!cards.length || !form || !variantInput || !submit) return;
    root.dataset.maxProductReady = "true";

    async function submitForm(event) {
      event.preventDefault();
      if (form.dataset.maxSubmitting === "true" || submit.disabled) return;

      form.dataset.maxSubmitting = "true";
      submit.disabled = true;
      if (formError) formError.textContent = "";
      if (formShell) formShell.classList.add("adding");

      try {
        const settings = window.MinimogSettings || {};
        const routes = settings.routes || {};
        const response = await fetch(routes.cart_add_url || "/cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: new FormData(form),
          credentials: "same-origin",
        });
        const item = await response.json();

        if (!response.ok || item.status) {
          throw new Error(item.description || item.message || "Unable to add this setup to the cart.");
        }

        if (window.Shopify && typeof window.Shopify.onItemAdded === "function") {
          await window.Shopify.onItemAdded(item);
        } else {
          window.location.assign((routes.cart_url || "/cart"));
        }
      } catch (error) {
        if (formError) {
          formError.textContent =
            error && error.message ? error.message : "Unable to add this setup to the cart.";
        }
      } finally {
        form.dataset.maxSubmitting = "false";
        submit.disabled = false;
        if (formShell) formShell.classList.remove("adding");
      }
    }

    if (form.dataset.maxSubmitReady !== "true") {
      form.addEventListener("submit", submitForm);
      form.dataset.maxSubmitReady = "true";
    }

    function select(card, updateUrl) {
      if (!card || card.getAttribute("aria-disabled") === "true") return;

      cards.forEach(function (candidate) {
        const selected = candidate === card;
        candidate.setAttribute("aria-checked", selected ? "true" : "false");
        candidate.tabIndex = selected ? 0 : -1;
      });

      variantInput.value = card.dataset.variantId;
      variantInput.dispatchEvent(new Event("input", { bubbles: true }));
      variantInput.dispatchEvent(new Event("change", { bubbles: true }));

      if (currentPrice) currentPrice.textContent = card.dataset.priceLabel || "";
      if (selectedName) selectedName.textContent = card.dataset.variantTitle || "";

      const available = card.dataset.available === "true";
      submit.disabled = !available;
      submit.textContent = available ? "Add to cart" : "Sold out";
      form.dataset.selectedBundle = card.dataset.bundle === "true" ? "true" : "false";

      if (updateUrl && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", card.dataset.variantId);
        window.history.replaceState({}, "", url.toString());
      }
    }

    cards.forEach(function (card, index) {
      card.addEventListener("click", function () {
        select(card, true);
      });

      card.addEventListener("keydown", function (event) {
        if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === "ArrowLeft" || event.key === "ArrowUp" ? -1 : 1;
        let nextIndex = (index + direction + cards.length) % cards.length;
        while (cards[nextIndex].getAttribute("aria-disabled") === "true" && nextIndex !== index) {
          nextIndex = (nextIndex + direction + cards.length) % cards.length;
        }
        cards[nextIndex].focus();
        select(cards[nextIndex], true);
      });
    });

    const requestedId = new URL(window.location.href).searchParams.get("variant");
    const requestedCard = cards.find(function (card) {
      return card.dataset.variantId === requestedId && card.getAttribute("aria-disabled") !== "true";
    });
    const initialCard =
      requestedCard ||
      cards.find(function (card) {
        return card.getAttribute("aria-checked") === "true" && card.getAttribute("aria-disabled") !== "true";
      }) ||
      cards.find(function (card) {
        return card.getAttribute("aria-disabled") !== "true";
      });

    select(initialCard, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
